<template>
  <div class="relative bg-indigo-600 w-full rounded-xl px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#4f46e5;">
    <div class="absolute top-4 right-4 opacity-20">
      <font-awesome-icon icon="fa-solid fa-people-group" class="text-white" style="font-size: 48px;" />
    </div>
    <div class="relative z-10 pr-20">
      <div class="text-white text-xs font-semibold uppercase tracking-wide mb-2">Total de Clientes</div>
      <div class="text-white text-5xl font-bold mb-1">{{ total }}</div>
      <div class="text-white/90 text-xs font-medium">Activos desde los inicios</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalCustomer",
  props: {
    total: {
      type: String,
      required: true,
    },
  },
};
</script>
